import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

const Container = styled.span`
  position: absolute !important; /* Outside the DOM flow */
  height: 1px;
  width: 1px; /* Nearly collapsed */
  overflow: hidden;
  clip: rect(1px 1px 1px 1px); /* IE 7+ only support clip without commas */
  clip: rect(1px, 1px, 1px, 1px); /* All other browsers */
`;

export const ScreenReaderContainer: FunctionComponent = ({ children }) => (
  <Container aria-live="polite" role="alert">
    {children}
  </Container>
);

export default ScreenReaderContainer;
